<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
console.log(window.screen)
export default {
  name: 'App'
}
</script>

<style lang="less">
html,body {
  width:100%;
  height:100%;
}
#app {
  width:100%;
  height:100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.mlayout {
  .minner {
      position:relative;
      width:100%;
      height:100%;
      overflow: scroll;
      &:before {
        content:'';
        display:block;
        position:absolute;
        top:0;
        width:100%;
        height:60vw;
        background:url(assets/images/mobile/top.png)top center/100% no-repeat;
      }
      .mcontainer {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        // overflow:hidden;
        z-index:2;
        .title {
          width:73.7vw;
          color:#fff;
          font-size:8vw;
          font-weight: bold;
          background:url(assets/images/mobile/title-line.png)bottom center /100% no-repeat;
          margin:8vw auto 7.3vw;
          padding-bottom:1.3vw;
        }
      }
      
    }
}
.viewer-toolbar > ul > li {
  background:#e60012;
}
.viewer-button {
  width:40px;
  height:40px;
  background:#e60012;
  right:10px;
  top:10px;
}
.viewer-button::before {
  left:10px;
  bottom:10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue